import { useLanguage } from './LanguageContext';
import { getTranslation } from './translations';

export function useTranslation() {
  const { locale } = useLanguage();
  
  return (key) => getTranslation(locale, key);
} 